import { useCallback, useRef } from 'react';

import useMinuteAlignedTick from './useMinuteAlignedTick';
import { getLocalDateString } from '../lib/time';

export default function useTimelineTicker({
  isToday,
  liveFollowActive,
  scrollToNow,
  updateCurrentTimeLine,
  reload,
  setSelectedDate,
  onMinuteTick,
}) {
  const currentDateRef = useRef(getLocalDateString());

  const handleDayChangeIfNeeded = useCallback(() => {
    if (!isToday) return false;

    const newDateStr = getLocalDateString();
    if (newDateStr === currentDateRef.current) return false;

    currentDateRef.current = newDateStr;

    setSelectedDate?.(newDateStr);
    return newDateStr;
  }, [isToday, setSelectedDate]);

  useMinuteAlignedTick(async () => {
    const dayChangedTo = handleDayChangeIfNeeded();
    const now = new Date();
    onMinuteTick?.((now.getHours() * 60) + now.getMinutes());

    updateCurrentTimeLine?.();
    if (liveFollowActive && isToday) {
      scrollToNow?.(true);
    }

    if (dayChangedTo) {
      await reload?.(dayChangedTo);
      return;
    }
  });
}
